import {useGetAndSet} from "./useGetAndSet";
import {createSetDriversDataAction} from "../actions/dataActions";


export const useDriversData = (params, dataFresh) => {
    return useGetAndSet("drivers", params, createSetDriversDataAction, dataFresh);
}